import React from 'react';
/* eslint-disable import/no-extraneous-dependencies */
import {
  Button, SvgIcon, Box, Skeleton,
} from '@mui/material';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/typography';
import SvgBack from '@digital-hig/icon/lib/build/icons/utility/back';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CompanyRootElement from './style';
import { SuccessStoriesContextConsumer } from '../../../common/context/success-stories/context';
import { SuccessStoriesStateInterface } from '../../../common/context/success-stories/interface';
import UnorderedList from '../../../common/unorderedList';
import { getKebabCase } from '../../../utils/srp.util';
import UnorderedListSkeleton from '../../../common/unorderedList/Skeleton';
import { BASENAME } from '../../../common/constants';
import { getBaseURL } from '../../../common/utilities';

const ProjectSummary = ({
  successStories = SuccessStoriesStateInterface.successStories,
  loading,
}) => {
  const { autodesk_solutions: autodeskSolutions = [], services_provided: servicesProvided = [], customer_industries: customerIndustries = [] } = successStories || {};
  const navigate = useNavigate();
  const param = useParams();
  const backToProfile = () => {
    const name = getKebabCase(successStories.provider_name);
    const baseUrl = getBaseURL(param.locale, `${BASENAME}/${name}/${successStories.provider_id}`);
    navigate(baseUrl);
  };
  const { t } = useTranslation();
  return (
    <CompanyRootElement>
      <Box className="project-section">
        <Box className="story-page-container">
          <Typography variant="headline-large" data-testid="Project summary" mb={7}>
            {t('Project summary')}
          </Typography>
          <Box className="project-summary">
            <Box component="ul">
              <Typography variant="headline-medium" mb={4}>
                {t('Duration & delivery')}
              </Typography>
              <Box component="li">
                {(!loading) && `${successStories?.project_duration || ''}`}
                {(loading) && <Skeleton animation="pulse" variant="text" width="30%" />}
              </Box>
              <Box component="li">
                {(!loading) && `${successStories?.project_delivery_date || ''}`}
                {(loading) && <Skeleton animation="pulse" variant="text" width="30%" />}
              </Box>
            </Box>
            {!loading && autodeskSolutions && (!!autodeskSolutions.length) && (
              <UnorderedList
                data={autodeskSolutions}
                title="Autodesk solutions"
              />
            )}
            {loading && <UnorderedListSkeleton />}
            {!loading && servicesProvided && (!!servicesProvided.length) && (
              <UnorderedList
                data={servicesProvided}
                title="Services provided"
              />
            )}
            {loading && <UnorderedListSkeleton />}
            {!loading && customerIndustries && (!!customerIndustries.length) && (
              <UnorderedList
                data={customerIndustries || []}
                title="Customer industry"
              />
            )}
            {loading && <UnorderedListSkeleton />}
          </Box>
          <Button
            className="back-button"
            onClick={backToProfile}
            startIcon={(
              <SvgIcon fontSize="medium">
                <SvgBack />
              </SvgIcon>
            )}
            data-wat-loc="profile return"
            data-wat-val="partner finder"
            variant="link-button"
          >
            {t('Back to Profile')}
          </Button>
        </Box>
      </Box>
    </CompanyRootElement>
  );
};
ProjectSummary.propTypes = {
  successStories: PropTypes.shape({}),
  loading: PropTypes.bool,
};
ProjectSummary.defaultProps = {
  successStories: {},
  loading: false,
};
export default SuccessStoriesContextConsumer(ProjectSummary);
